import { NOTIFICATIONS_NOTIFY_TYPE, NOTIFICATIONS_CLOSE_TYPE } from '../../constants/actionTypes';
import { INotificationsState, ENotificationStyle } from '../../types/notifications';
import { TReduxActions } from '../../types/redux';

const defaultNotifications: INotificationsState = {
  text: null,
  style: ENotificationStyle.Default,
};

export function notificationsReducer(state: INotificationsState = defaultNotifications, action: TReduxActions) {
  switch (action.type) {
    case NOTIFICATIONS_NOTIFY_TYPE:
      return {
        ...state,
        text: action.text,
        style: action.style,
      };

    case NOTIFICATIONS_CLOSE_TYPE:
      return {
        ...state,
        text: null,
      };
  }

  return state;
}
